<template>
  <router-link :to="{ name: +obj.type==8 ? 'topic-lib-detail': 'Details', params: { id: obj.id } }">
    <div class="activity-item">
      <el-image :src="obj.banner" fit="fit" class="activity-item-img">
      </el-image>
      <div class="activity-content">
        <div class="content-title">
          {{ obj.title }}
        </div>
        <div class="content-row">
          <div class="type type_color_green"></div>
          <div class="create-name">主办方：{{ obj.sponsor }}</div>
        </div>
        <div class="content-row">
          <div class="type type type_color_orange"></div>
          <div class="create-name">
            活动日期：{{ obj.start_time }}-{{ obj.end_time }}
          </div>
        </div>
        <div
          class="activity-content-status activity-content-status_notstarted"
          :class="[statusBgColor]"
        >
          <span class="status-text">{{ obj.status | statusText }}</span>
        </div>
      </div>
      <div class="activity-bottom">
        <div class="block" v-if="!isShowJoin">
          <div class="icon-item">
            <i class="iconfont icon-dianzan4"></i>
            <span class="nub">{{ obj.mark }}</span>
          </div>
          <div class="icon-item" v-if="obj.type != 11">
            <i class="iconfont icon-pinglun-tianchong"></i>
            <span class="nub">{{ obj.comment }}</span>
          </div>
          <div class="icon-item">
            <i class="iconfont icon-chakan2"></i>
            <span class="nub">{{ obj.views }}</span>
          </div>
        </div>
        <div class="block" v-else>
          <div class="icon-item">
            <svg
              t="1642383687595"
              class="icon svg"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4227"
              width="48"
              height="48"
            >
              <path
                d="M406.6 330.5m-176.6 0a176.6 176.6 0 1 0 353.2 0 176.6 176.6 0 1 0-353.2 0Z"
                p-id="4228"
                fill="#999999"
              ></path>
              <path
                d="M491.2 517.1H352.4C191.7 517.1 61.5 647.3 61.5 808c0 48.5 39.4 87.9 87.9 87.9h528.2c38.1 0 69-30.9 69-69v-54.4c0-141-114.4-255.4-255.4-255.4zM605.8 329.1c0 46.7-17 89.4-45.2 122.3-3.3 3.8-3.1 9.5 0.4 13.2 24.4 25.3 58.7 41 96.6 41 74.6 0 135-60.7 134.5-135.4-0.5-73-59.9-132.7-132.9-133.5-20.6-0.2-40.1 4.1-57.6 12.2-6.2 2.9-9.3 10-7 16.4 7.3 19.8 11.2 41.3 11.2 63.8z"
                p-id="4229"
                fill="#999999"
              ></path>
              <path
                d="M681.8 527.5H643c-7.9 0-10.8 10.4-4 14.5 77.3 45.9 129.1 130.2 129.1 226.7v56.1c0 15.1-4.7 29.1-12.8 40.7-3.6 5.1 0 12.2 6.3 12.2H854c35.2 0 63.8-28.6 63.8-63.8v-50.2c0-130.5-105.7-236.2-236-236.2z"
                p-id="4230"
                fill="#999999"
              ></path>
            </svg>
            <span class="num">{{ obj.join_num }}</span>
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  components: {},
  props: {
    obj: Object
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    statusBgColor() {
      let rule = {
        2: "activity-content-status_notstarted",
        3: "activity-content-status_starting",
        4: "activity-content-status_end"
      };
      return rule[this.obj.status];
    },
    //
    isShowJoin() {
      const ACTIVITY_TYPE = {
        answer: 8,
        clock: 5
        // works_clock: 11
      };
      let showJoinActivity = [
        ACTIVITY_TYPE.answer,
        ACTIVITY_TYPE.clock
        // ACTIVITY_TYPE.works_clock
      ];
      console.log("======", this.obj.type);
      if (showJoinActivity.includes(+this.obj.type)) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {},
  created() {},
  mounted() {},
  filters: {
    statusText(value) {
      let rule = {
        2: "未开始",
        3: "正在进行",
        4: "已结束"
      };
      return rule[value];
    }
  }
};
</script>
<style lang="less" scoped>
@green: #58b75b;
@orange: #ffb463;
@gray: #999999;
/deep/ .el-image__error {
  background-color: @green;
  color: #fff;
}
.activity-item {
  font-size: 12px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  width: 380px;
  border-radius: 10px;
  overflow: hidden;

  &-img {
    height: 160px;
    width: 380px;
  }
  .activity-content {
    padding: 0 10px 28px;
    box-sizing: border-box;
    position: relative;
    border-bottom: 1px solid #eee;
    .content {
      &-title {
        color: #333;
        font-size: 15px;
        line-height: 1.5;
        height: 45px;
        margin-top: 20px;
        margin-bottom: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      &-row {
        display: flex;
        align-items: center;
        margin-right: 50px;
        color: @gray;

        line-height: 1.6;
        .type {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: #f40;
          margin-right: 16px;
          &_color_green {
            background-color: @green;
          }
          &_color_orange {
            background-color: @orange;
          }
        }
        .create-name {
          flex: 1;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
    &-status {
      position: absolute;
      right: 0;
      bottom: 29px;
      background-color: @green;
      color: #fff;
      width: 70px;
      height: 25px;
      padding-right: 2px;
      line-height: 25px;
      text-align: right;
      display: flex;
      font-size: 12px;
      white-space: nowrap;
      padding-left: 7.5px;
      align-items: center;
      justify-content: center;
      &::after {
        content: "";
        display: block;
        width: 0;
        height: 0;
        border-top: 12.5px solid transparent;
        border-bottom: 12.5px solid transparent;
        border-left: 7.5px solid #fff;
        border-right: 7.5px solid transparent;
        position: absolute;
        left: 0;
        top: 0;
      }
      &_notstarted {
        background-color: @orange;
      }
      &_end {
        background-color: @gray;
      }
      &_starting {
        background-color: @green;
      }
    }
  }
  .activity-bottom {
    //display: flex;
    //align-items: center;
    //height: 60px;
    //padding: 0 20px;
    .block {
      display: flex;
      align-items: center;
      height: 60px;
      padding: 0 20px;
      .icon-item {
        font-size: 12px;
        color: @gray;
        margin-right: 15px;
        display: flex;
        align-items: center;

        .iconfont {
          font-size: 11px;
          margin-right: 3px;
          color: @gray;
        }
        .svg {
          display: inline-block;
          width: 15px;
          height: 15px;
        }
      }
    }
  }
}

@media screen and (max-width: 1400px) and(min-width: 600px) {
  .activity-content {
    &-status {
      // transform: scale(0.5);
      .status-text {
        transform: scale(0.58);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/activityItem.vue